export enum EFiltersActions {
  SET_FILTER = 'filters/SET_FILTER',
  PARTIAL_FILTER_RESET = 'filters/PARTIAL_FILTER_RESET',
  RESET_FILTER = 'filters/RESET_FILTER',
  REFRESH_FILTER = 'filters/REFRESH_FILTER'
}
